import * as React from "react";
import { forwardRef } from "react";
const SvgEvents = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M1.4 9.5c.8 0 1.4-.7 1.4-1.5 0-.3-.1-.6-.2-.8-.2-.3-.4-.5-.7-.6s-.5-.1-.8-.1c-.2.1-.5.2-.7.4-.2.2-.3.5-.4.8 0 .3 0 .6.1.9.1.3.3.5.5.7s.5.2.8.2zM2.1 5.9V2H.7v3.9h1.4zM.7 10.1V14h1.4v-3.9H.7zM16 3.5v9c0 .8-.6 1.5-1.4 1.5H6.1c-.4 0-.7-.2-1-.4-.3-.3-.4-.7-.4-1.1v-3L3.3 8l1.4-1.5v-3c0-.4.1-.8.4-1.1.3-.2.7-.4 1-.4h8.4c.9 0 1.5.7 1.5 1.5zm-1.2-.2H6v3.8l-.9.9.9.9v3.8h8.8V3.3zM7.6 5.8h5.6v1.5H7.6V5.8zm0 3h4.2v1.5H7.6V8.8z" }));
const ForwardRef = forwardRef(SvgEvents);
export default ForwardRef;
